
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>{`Scénario A: Sans app de «Proximity Tracing»`}</h4>
    <p>{`Les personnes que vous avez infectées sont toujours sans symptômes. La plupart
d'entre elles n'ont pas conscience du danger qu'elles représentent et
`}<strong parentName="p">{`continuent à propager le virus`}</strong>{`. Cela fait déjà une semaine que vous-même
avez été contaminé.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;